import React from 'react'
import { List, Text, Flex } from '@leverege/ui-elements'

import S from './OidcItem.css'

/**
 * @function OidcItem A list item representing an oidc client, rendered by the <List.Dynamic /> component.
 * @component  
 * @property {object} props.item An oidc client object
 * @property {function} props.onEvent A selection handler for the oidc client
 * @returns {element}
 */
export default function OidcItem( props ) {
  const { item = {}, ...rest } = props 

  return ( 
    <List.Item className={S.item} key={item.name} item={item} {...rest}>
      <Flex variant="rowM">
        {item.name}
        <Text variant="info" style={{ textAlign : 'right', flex : 1 }}>
          {item.alias}
        </Text>
      </Flex>
    </List.Item>
  )
}
